const documentGroups = new Set(['Warranty', 'Manual', 'Contracts']);

export const groupDocuments = (documents) => {
  if (Array.isArray(documents)) {
    return documents.reduce(
      (acc, document) => {
        if (document.isImportantDocument) {
          acc.priority.push(document);
        }

        if (!documentGroups.has(document.type)) {
          acc.General.push(document);
          return acc;
        }

        if (!acc[document.type]) {
          acc[document.type] = [];
        }

        acc[document.type].push(document);
        return acc;
      },
      { priority: [], General: [] }
    );
  }

  return { priority: [], General: [] };
};
